export default function PermissionNames({ permissions }) {
    return permissions.map((permission, index) => (
        <span key={permission.scope}>
            {index > 0 ? (index === permissions.length - 1 ? " and " : ", ") : null}
            <code className="font-mono">{permission.scope}</code>
        </span>
    ));
}
